import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getDealers, GetDealersApiParameter } from "@insite/client-framework/Services/DealerService";
import { DealerCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { ApiHandlerNoApiParameter } from "@ucs/Store/CustomHandlerCreator";

type CustomHandlerType = ApiHandlerNoApiParameter<GetDealersApiParameter, DealerCollectionModel>;


export const RequestDataFromApi: CustomHandlerType = async props => {
    const response = await getDealers({
        name: "",
        longitude: 0,
        latitude: 0,
        radius: 99999,
        additionalQueryStringParameters: { useDefaultLocation: true },
    });
    props.apiResult = response;
};

export const DispatchCompleteLoadDealers: CustomHandlerType = props => {
    props.dispatch({
        type: "Custom/SetLoadDealersDropdown",
        collection: props.apiResult,
    });
};

export const chain = [RequestDataFromApi, DispatchCompleteLoadDealers];

const customLoadDealers = createHandlerChainRunner(chain, "CustomLoadDealers");
export default customLoadDealers;